// extracted by mini-css-extract-plugin
module.exports = {"buttonMovile":"ProjectCreateButton_buttonMovile__y4uUc"};